import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home.vue'
import Zdqd from '@/components/Zdqd'
import Wjtz from '@/components/Wjtz'
import ProjectList from '@/components/ProjectList'
import ProjectDetail from '@/components/ProjectDetail'
import Lst from '@/components/Lst'
import Jjzb from '@/components/Jjzb'
import zsyz from '@/components/zsyz'
import Ggcx from '@/components/Ggcx'
import UserCenter from '@/components/UserCenter'
import News from '@/components/News'
import Ztjz from '@/components/ztjz'
import Cgk from '@/components/cgk'
import Bdql from '@/components/bdql'
import Zbjb from '@/components/zbjb'
import Xcbd from '@/components/xcbd'
import xcbdMore from '@/components/xcbd-more.vue'
import xcbdDetail from '@/components/xcbd-detail.vue'
import Login from '@/views/login.vue'
import zsyzOrigin from '@/components/zsyz-origin.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        id: 'login',
        title: '登录页',
      },
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        id: 'index',
        title: '首页',
      },
    },
    {
      path: '/zdqd',
      name: 'Zdqd',
      component: Zdqd,
      meta: {
        id: 'zdqd',
        title: '重点清单',
      },
    },
    {
      path: '/wjtz',
      name: 'Wjtz',
      component: Wjtz,
      meta: {
        id: 'wjtz',
        title: '稳进提质',
      },
    },
    {
      path: '/projectlist',
      name: 'ProjectList',
      component: ProjectList,
      meta: {
        id: 'projectlist',
        title: '项目列表',
      },
    },
    {
      path: '/projectdetail',
      name: 'ProjectDetail',
      component: ProjectDetail,
      meta: {
        id: 'projectdetail',
        title: '项目详细',
      },
    },
    {
      path: '/lst',
      name: 'Lst',
      component: Lst,
      meta: {
        id: 'lst',
        title: '亮晒台',
      },
    },
    {
      path: '/jjzb',
      name: 'Jjzb',
      component: Jjzb,
      meta: {
        id: 'jjzb',
        title: '经济指标',
      },
    },
    {
      path: '/zsyz',
      name: 'zsyz',
      component: zsyz,
      meta: {
        id: 'zsyz',
        title: '招商引资',
      },
    },
    {
      path: '/ggcx',
      name: 'Ggcx',
      component: Ggcx,
      meta: {
        id: 'ggcx',
        title: '改革创新',
      },
    },
    {
      path: '/usercenter',
      name: 'UserCenter',
      component: UserCenter,
      meta: {
        id: 'usercenter',
        title: '改革创新清单',
      },
    },
    {
      path: '/news',
      name: 'News',
      component: News,
      meta: {
        id: 'news',
        title: '信息快递',
      },
    },
    {
      path: '/ztjz',
      name: 'Ztjz',
      component: Ztjz,
      meta: {
        id: 'ztjz',
        title: '总体进展',
      },
    },
    {
      path: '/cgk',
      name: 'Cgk',
      component: Cgk,
      meta: {
        id: 'cgk',
        title: '"6+2"指标',
      },
    },
    {
      path: '/bdql',
      name: 'Bdql',
      component: Bdql,
      meta: {
        id: 'bdql',
        title: '拔钉清零',
      },
    },
    {
      path: '/zbjb',
      name: 'Zbjb',
      component: Zbjb,
      meta: {
        id: 'zbjb',
        title: '专报简报',
      },
    },
    {
      path: '/xcbd',
      name: 'Xcbd',
      component: Xcbd,
      meta: {
        id: 'xcbd',
        title: '宣传报道',
      },
    },
    {
      path: '/xcbdMore',
      name: 'XcbdMore',
      component: xcbdMore,
      meta: {
        id: 'xcbdMore',
        title: '宣传报道更多',
      },
    },
    {
      path: '/xcbdDetail',
      name: 'XcbdDetail',
      component: xcbdDetail,
      meta: {
        id: 'xcbdDetail',
        title: '宣传报道详细',
      },
    },
    {
      path: '/zsyzOrigin',
      name: 'ZsyzOrigin',
      component: zsyzOrigin,
      meta: {
        id: 'zsyzOrigin',
        title: '招商引资6月',
      },
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js